import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceStore } from '@y42/datasource';
import { UiModelingGitFactoryService } from './ui-modeling-git-factory.service';
import { UiModelingState } from './ui-modeling.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-modeling', idKey: '$path' })
export class UiModelingStore extends DatasourceStore<UiModelingState> {
  constructor(protected readonly gitFactory: UiModelingGitFactoryService) {
    super('UI-Modeling', gitFactory);
  }
}
